<template>
    <v-sheet
        class="nav-bar-content d-flex"
        height="100%"
        width="100%"
    >
        <span class="d-flex mr-16" style="justify-content: space-between;">
            <a href="/">
                <v-img
                    v-if="this.$vuetify.breakpoint.smAndUp"
                    src="../assets/images/logo.jpg"
                    lazy-src="../assets/images/logo.jpg"
                    eager
                    height="70"
                    width="240"
                    max-width="240"
                />
                <v-img
                    v-else
                    src="../assets/images/smc-logo.svg"
                    lazy-src="../assets/images/smc-logo.svg"
                    eager
                    height="70"
                    width="180"
                    max-width="180"
                    class="ml-n7"
                />
            </a>
            
            <span v-if="isAuthenticated && isOrganization" class="d-flex">
                <messages-inbox />
                <recent-actions />
            </span>
        </span>
        
        <span v-if="isAuthenticated && isOrganization" class="search-wrapper d-flex mx-auto mt-4" style="gap: 5px">
            <global-search
                :searchTermProp="globalSearchTerm"
                @update:searchTermProp="val => globalSearchTerm = val"
            />
            <organization-branch-picker @updateOrganizationBranch="updateOrganizationBranch" />
        </span>
        
        <nav class="d-flex" v-if="isOrganization">
            <v-tooltip v-if="$store.getters['user/isWeBuyCars'] && this.$vuetify.breakpoint.mdAndUp" bottom>
                <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        class="my-auto mx-2 px-2 secondary--text text-none"
                        to="/dashboard"
                        v-bind="attrs"
                        v-on="on"
                        tile
                        text
                    >
                        <v-icon>mdi-chart-bar</v-icon>
                    </v-btn>
                </template>
                
                <span>{{ isOrganizationAdmin ? 'Admin Dashboard' : 'Dashboard' }}</span>
            </v-tooltip>
            
            <v-btn
                v-if="this.$vuetify.breakpoint.mdAndUp"
                class="my-auto mx-2 px-2 text-none"
                color="primary"
                to="/active-requests"
            >
                <v-icon class="mr-1" small>mdi-wrench</v-icon>
                Active Requests
            </v-btn>
            
            <v-menu v-if="isAuthenticated && this.$vuetify.breakpoint.mdAndUp"
                    offset-y
            >
                <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        color="secondary"
                        dark
                        v-bind="attrs"
                        v-on="on"
                        class="my-auto ml-2 mr-3 text-none"
                    >
                        <v-icon class="mr-1">mdi-account</v-icon>
                        Account
                    </v-btn>
                </template>
                <v-list>
                    <v-list-item to="/account">
                        <v-list-item-title>Profile</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="signOutUser()">
                        <v-list-item-title>Logout</v-list-item-title>
                    </v-list-item>
                </v-list>
            </v-menu>
        </nav>
        <nav class="d-flex ml-auto" v-else>
            
            <span
                v-if="isAuthenticated && this.$vuetify.breakpoint.mdAndUp"
                class="logged-in-menu top-menu-link mx-2 my-auto pa-1"
            >
                <v-btn
                    v-if="this.$vuetify.breakpoint.mdAndUp"
                    to="/home"
                    class="secondary--text text-none"
                    tile
                    text
                >
                    <v-icon class="mr-1">mdi-car</v-icon>
                    Quote
                </v-btn>
                <v-btn class="secondary--text text-none" to="/my-garage" tile text>
                    <v-icon class="mr-1">mdi-home-variant</v-icon>
                    My Garage
                </v-btn>
                <v-btn
                    class="secondary--text text-none"
                    to="/active-requests"
                    tile
                    text
                >
                    <v-icon class="mr-1">mdi-wrench</v-icon>
                    Active Requests
                </v-btn>
            </span>
            
            <v-btn
                v-if="this.$vuetify.breakpoint.mdAndUp"
                class="my-auto mx-2 px-2 secondary--text text-none"
                to="/about"
                tile
                text
            >
                About
            </v-btn>
            
            <v-btn
                v-if="this.$vuetify.breakpoint.mdAndUp"
                class="my-auto mx-2 px-2 secondary--text text-none"
                to="/contact"
                tile
                text
            >
                Contact
            </v-btn>
            
            <v-btn
                v-if="this.$vuetify.breakpoint.mdAndUp"
                class="my-auto mx-2 px-2 secondary--text text-none"
                to="/faq"
                tile
                text
            >
                FAQs
            </v-btn>
            
            <v-btn
                v-if="!isAuthenticated && this.$vuetify.breakpoint.mdAndUp"
                class="my-auto mx-2 text-none"
                text
                tile
                to="/account/signup"
            >

                Register
            </v-btn>
            
            <v-btn
                v-if="!isAuthenticated && this.$vuetify.breakpoint.mdAndUp"
                class="my-auto mx-2 text-none"
                to="/account/login"
                color="primary"
            >
                Login
            </v-btn>
            
            <v-menu v-if="isAuthenticated && this.$vuetify.breakpoint.mdAndUp"
                    offset-y
            >
                <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        color="secondary"
                        dark
                        v-bind="attrs"
                        v-on="on"
                        class="my-auto ml-2 mr-3 text-none"
                    >
                        <v-icon class="mr-1">mdi-account</v-icon>
                        Account
                    </v-btn>
                </template>
                <v-list>
                    <v-list-item to="/account">
                        <v-list-item-title>Profile</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="signOutUser()">
                        <v-list-item-title>Logout</v-list-item-title>
                    </v-list-item>
                </v-list>
            </v-menu>
            
        </nav>
        
        <Slide
            right
            class="sidebar-menu"
            v-if="this.$vuetify.breakpoint.smAndDown"
            closeOnNavigation
        >
            <router-link to="/home" v-if="!isAuthenticated || !isOrganization">
                <v-icon color="white">mdi-home</v-icon>
                <span>Home</span>
            </router-link>
            <router-link to="/my-garage" v-if="isAuthenticated && !isOrganization">
                <v-icon color="white">mdi-home-variant</v-icon>
                <span>My Garage</span>
            </router-link>
            <router-link to="/active-requests" v-if="isAuthenticated">
                <v-icon color="white">mdi-wrench</v-icon>
                <span>Active Requests</span>
            </router-link>
            <router-link to="/about" v-if="!isAuthenticated || !isOrganization">
                <v-icon color="white">mdi-information-variant</v-icon>
                <span>About</span>
            </router-link>
            <router-link to="/contact" v-if="!isAuthenticated || !isOrganization">
                <v-icon color="white">mdi-phone</v-icon>
                <span>Contact</span>
            </router-link>
            <router-link to="/faq" v-if="!isAuthenticated || !isOrganization">
                <v-icon color="white">mdi-frequently-asked-questions</v-icon>
                <span>FAQs</span>
            </router-link>
            <router-link to="/account/login" v-if="!isAuthenticated">
                <v-icon color="white">mdi-login</v-icon>
                <span>Login</span>
            </router-link>
            <a @click="signOutUser()" v-if="isAuthenticated">
                <v-icon color="white">mdi-logout</v-icon>
                <span>Logout</span>
            </a>
            <router-link to="/account" v-if="isAuthenticated">
                <v-icon color="white">mdi-account</v-icon>
                <span>Account</span>
            </router-link>
            <router-link to="/account/register" v-if="!isAuthenticated">
                <v-icon color="white">mdi-pencil</v-icon>
                <span>Register</span>
            </router-link>
        </Slide>
        
        <v-btn v-if="isAuthenticated" @click="goBack" color="primary" class="d-none d-md-flex" style="position: fixed; right: 15px; top: 85px;">
            <v-icon class="mr-1" small>mdi-arrow-left</v-icon>
            Back
        </v-btn>
        
    </v-sheet>
</template>

<script>
import { Slide } from 'vue-burger-menu';
import recentActions from '@/components/recent-actions/index';
import messagesInbox from '@/components/messages-inbox/index';
import globalSearch from '@/components/global-search';
import organizationBranchPicker from '@/components/organization-branch-picker';

export default {
    name: 'app-bar-navigation',
    components: {
        Slide,
        recentActions,
        messagesInbox,
        globalSearch,
        organizationBranchPicker,
    },
    data: function () {
        return {
            globalSearchTerm: '',
        };
    },
    computed: {
        user() {
            return this.$store.state.user.user;
        },
        isAuthenticated() {
            if (this.user) {
                return true;
            }
            return false;
        },
        isOrganization() {
            return this.$store.getters['user/isOrganization'];
        },
        organization() {
            return this.$store.getters['user/getOrganization'];
        },
        organizationBranch() {
            return this.organization.organizationBranches[0];
        },
        isOrganizationAdmin() {
            return this.$store.getters['user/isOrganizationAdmin'];
        },
    },
    methods: {
        onItemClick(event, item) {
            switch (item.action) {
                case 'Logout':
                    this.signOutUser();
                    break;
            }
        },
        updateOrganizationBranch() {
            this.globalSearchTerm = '';
        },
        signOutUser() {
            this.$store.dispatch('user/removeUser');
            this.$store.dispatch('quoteRequestCreate/resetQuoteRequest');
            this.$store.dispatch('notifications/clearNotifications');
            window.location = '/';
        },
        goBack() {
            if (window.history.length > 1) {
                this.$router.back();
            }
            else {
                this.$router.push('/home');
            }
        },
    },
};
</script>

<style>
@import "../assets/scss/components/sidebar-menu.scss";

.top-menu-link {
  margin-top: 22px;
  margin-bottom: 22px;
}

.top-menu-link.logged-in-menu {
  margin-top: 13px;
  margin-bottom: auto;
}

.logged-in-menu {
  border: 1px solid #575757;
  border-radius: 5px;
  background-color: #fff;
}

.smc-quote-menu {
  background: transparent;
  padding: 15px;
  box-shadow: none;
}

.smc-quote-menu.v-menu__content {
  box-shadow: none;
}

.smc-quote-menu .smc-quote-menu-wrapper {
  background-color: #ffffff;
  padding: 20px 40px;
  width: 400px;
  box-shadow: 5px 0px 10px 5px rgba(0, 0, 0, 0.3),
    0px 5px 5px -3px rgba(0, 0, 0, 0.2);
}

.smc-quote-menu .smc-quote-menu-wrapper:after {
  content: " ";
  position: absolute;
  right: 207px;
  top: 0;
  border-top: none;
  border-right: 14px solid transparent;
  border-left: 14px solid transparent;
  border-bottom: 15px solid #ffffff;
}
</style>
